import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { Table, Loader } from 'react-inv-forms';

import { RootState } from '../../../../redux/reducers';
import {
  studentFinderActionsInterfaces,
  studentFinderActions,
  studentFinderActionsSelectors,
} from '../../../../redux/staticViews/studentFinder';

import withMobileAsideHandler, { WithMobileAsideHandlerProps } from '../../../../hoc/withMobileAsideHandler';
import withDynamicTabLauncher, { WithDynamicTabLauncherProps } from '../../../../hoc/withDynamicTabLauncher';
import TableCellTypes from '../../../../helpers/tableCellTypes';

import { TabConfig } from '../../../../interfaces/global';

import { TabRightPanel } from '../../../../styles/tabContainers';
import { TableContainer } from './StudentInfo.style';

const { getSubjectForStudentList } = studentFinderActions;

type MapStateToProps = ReturnType<typeof mapStateToProps>;
type MapDispatchToProps = ReturnType<typeof mapDispatchToProps>;

type StudentSubjectsProps = StaticViewComponent &
  MapStateToProps &
  MapDispatchToProps &
  WithMobileAsideHandlerProps &
  WithDynamicTabLauncherProps &
  RouteComponentProps;

/**
 *  Widok przedmiotów prowadzącego, w których występuje wyszukany student.
 *
 */
// export dodany w celu wyświetlenia komentarza w dokumentacji, ponieważ opakowane funkcje mają problem z wyświetlaniem
export const StudentSubjects = ({
  showAsideButton,
  singleStudent,
  subjectForStudentList,
  getSubjectForStudentList,
  openNewTab,
  history,
}: StudentSubjectsProps): JSX.Element | null => {
  useEffect(() => {
    if (!singleStudent) {
      return;
    }

    if (singleStudent.studentId !== subjectForStudentList.studentId) {
      getSubjectForStudentList(singleStudent.studentId, singleStudent.semestrAkademicki, singleStudent.rokAkademicki);
    }
  }, [singleStudent]);

  const openSubjectTab = ({
    przedmiotId,
    przedmiotNazwa,
    semestrAkademicki,
    rokAkademicki,
    wydzialZlecajacyKod,
  }: TabConfig): void => {
    openNewTab(
      {
        titleTranslationKey: przedmiotNazwa,
        tabType: 'strona-przedmiotu',
        itemId: `${przedmiotId}_${rokAkademicki}-${semestrAkademicki}_${wydzialZlecajacyKod}`,
      },
      history,
      false,
      undefined,
      `${singleStudent?.studentAlbum}`,
    );
  };

  return !singleStudent ? null : (
    <TabRightPanel withFullWidth={showAsideButton}>
      <TableContainer data-cy='tableContainer_studentFinder'>
        {subjectForStudentList.loading ? (
          <Loader
            style={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              fontSize: '32px',
            }}
          />
        ) : (
          <Table
            tableLayout='auto'
            columns={subjectForStudentList.columns}
            dataSource={TableCellTypes.generateTableContent(subjectForStudentList.data, subjectForStudentList.columns)}
            pagination={false}
            onRow={(record: any): any => ({
              onClick: (): void => openSubjectTab(record),
            })}
          />
        )}
      </TableContainer>
    </TabRightPanel>
  );
};

// użycie hoca zamiast hooka spowodowane chęcią zachowania jednolitości (i tak by trzeba było opakować inne elementy logiki)
const mapStateToProps = (
  state: RootState,
): studentFinderActionsInterfaces.SubjectListState &
  Pick<studentFinderActionsInterfaces.StudentFinderState, 'singleStudent'> => ({
  subjectForStudentList: studentFinderActionsSelectors.getSubjectList(state),
  singleStudent: studentFinderActionsSelectors.getSingleStudent(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  getSubjectForStudentList: (
    studentId: number,
    semestrAkademicki: string,
    rokAkademicki: string,
  ): studentFinderActionsInterfaces.SubjectForStudentList =>
    dispatch(getSubjectForStudentList(studentId, semestrAkademicki, rokAkademicki)),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withMobileAsideHandler,
  withDynamicTabLauncher,
)(StudentSubjects) as React.ComponentType<any>;
